import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part1 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic2: 'medsurg-cinematic-1-2', //CAN BE REPLACED
        chapterCinematic3: 'medsurg-cinematic-1-3',
        chapterCinematic4: 'medsurg-cinematic-1-4',
        chapterCinematic5: 'medsurg-cinematic-1-5',
        chapterCinematic6: 'medsurg-cinematic-1-6',
        chapterCinematic7: 'medsurg-cinematic-1-7',
        chapterCinematic8: 'medsurg-cinematic-1-8',
        chapterCinematic9: 'medsurg-cinematic-1-9',
        chapterCinematic10: 'medsurg-cinematic-1-10',
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Talk6: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part1.id;
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
			title: 'Vitals - 07:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Samuel Holder, a 48-year-old male, African American patient, has been admitted to the medical surgical unit for evaluation of multisystem problems related to chronic renal failure. He is scheduled for an intravenous pyelogram (IVP).</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>Chronic renal failure</li><li>No allergies</li><li>African American</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>Hydroclorothiazide (HCTZ)</li><li>Amlodipine</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>Patient should be NPO for 8 hours before IVP procedure</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

        this.scenario.displayBeginScenarioUI(
            './assets/images/scenario1/begin-scenario-scenario1.jpg', 
            'start1', 
			1,
            () => {
                context.segment1Step1IntroWalking();
		});
		//TO BE RE-ADDED WHEN DONE
		//context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
	});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
		this.scenario.displayModalPop(
			null,
            'Skipping to part 2',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 1',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {
				}, true);
				context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '6', '2', false, false);
				context.TalkCount = 6;
				context.ActionCount = 2;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(3250, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
			title: 'Vitals - 10:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Samuel Holder'
				},
				{
					description: 'Room: #1'
				},
				{
					description: 'Age: 48'
				},
				{
					description: 'Sex: Male'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).holderBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).holderNursesID),
			lab: [
				{
					title: 'Test Name'
				},
				{
					title: 'Results'
				},
				{
					title: 'Normal Range'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).holderVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrHolderID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment1TalkDay();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: "Do you know why you're here today?",
					onClicked: () => {
						this.segment1TalkWhy();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: 'Have you had any food or drink in the last eight hours?',
					onClicked: () => {
						this.segment1TalkFood();
					},
					disable: () => this.Talk5
				},
				{
					toppx: '550px',
					titletext: "Do you have any allergies?",
					onClicked: () => {
						this.segment1TalkAllergy();
					},
					disable: () => this.Talk6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Weigh Patient',
					onClicked: () => {
						this.segment1ActionWeight();
					},
					disable: () => this.Action2
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.hideMoveShowTalk(this.ActionInstanceID2, this.ActionInstanceID1, () => {
				});
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			titletext: 'How are you feeling?',
			scenario: this,
			isTalks: true,
			loadQuiz: true,
			extBottom: true,
			extText: "I'm okay. I'm nervous about the procedure.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);

				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;

				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);

				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Headache',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Restless',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Itchy",
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic4, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			scenario: this,
			loadQuiz: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 0,
			extBottom: true,
			extText: "Zero - I have no pain.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)

				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic5, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			titletext: 'Do you know what day it is?',
			isTalks: true,
			scenario: this,
			loadQuiz: true,
			extBottom: true,
			extText: "Today is Tuesday.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
								
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: 'Patient Observation',
					talktext2: 'Mental Status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
				this.playVideoChapter(this.chapterIds.chapterCinematic6, () => {
					this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
				});
                context.scenario.endModalPop();
            }
        );
	}

	private segment1TalkWhy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			titletext: "Do you know why you're here today",
			isTalks: true,
			scenario: this,
			loadQuiz: true,
			extBottom: true,
			extText: "I have an appointment for an IVP.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 1100,
					talktext1: 'Patient Observations',
					talktext2: 'Mental status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic7, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkFood() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '470px',
			titletext: 'Have you had any food or drink in the last eight hours?',
			scenario: this,
			isTalks: true,
			loadQuiz: true,
			extBottom: true,
			extText: "Nope - I haven't had anything to eat or drink since last night.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
								
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'NPO status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No food or drink in the last eight hours',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Had food and/or drink in the last eight hours',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic8, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkAllergy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '570px',
			titletext: "Do you have any allergies?",
			isTalks: true,
			loadQuiz: true,
			scenario: this,
			extBottom: true,
			extText: "Nope, not that I know of.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
								
				this.Talk6 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'Allergies',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'None',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Iodine/Seafood',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Peanuts',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Dairy',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic9, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.hideMoveShowTalk(this.ActionInstanceID2, this.MoveInstanceID, () => {
			context.scenario.update508Window(Window508Type.TransformUI);
			this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
				toptitle: 'Action',
				toppx: '70px',
				loadQuiz: true,
				scenario: this,
				titletext: 'Temperature',
				vitaltext: '98.6',
				vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
				onSubmit: () => {
					this.Action11 = true;
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
						list: '<li>Temperature : 98.6</li>',
					})
					context.scenario.updateScore(100);
					setTimeout(() => {
						context.scenario.update508Window(Window508Type.TalkActionsUI);
					}, 1000);
					context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
					context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
					context.checkIfSubMenu();
				}
			});setTimeout(() => {
				this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
					loadQuiz: false,
				});
			}, 2000);
		}, true)
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '158/94',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Blood Pressure : 158/94</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '92',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Pulse : 92</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '20',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Respirations : 20</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '99% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>02 Sat Level : 99% room air</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionWeight() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Weigh Patient',
			vitaltext: '185 lbs / 84 kg',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_weight.png',
			onSubmit: () => {
				context.scenario.update508Window(Window508Type.TalkActionsUI);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment1AfterCounts();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private segment1AfterCounts() {
		var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic10, () => {});
		context.scenario.showProvider(
			"I have come to escort Mr. Holder to Radiology for his IVP procedure. You'll be notified when he returns. Please exit the room.",
			() => {
				context.scenario.destroyAllUIInstances();
				context.segment1Part5Debrief();
			}
		);
	}
}